import {
  DashboardOutlined,
  SettingOutlined,
  UserOutlined,
  CloudServerOutlined,
  BookOutlined,
  ReadOutlined,
  FormOutlined,
  TeamOutlined,
  DatabaseOutlined,
  CrownOutlined,
  TrophyOutlined,
  DollarOutlined,
  OrderedListOutlined,
  FileProtectOutlined,
  ToolOutlined,
  FileTextOutlined,
  TransactionOutlined,
  AuditOutlined,
  SoundOutlined,
  CustomerServiceOutlined,
} from '@ant-design/icons';
import { APP_PREFIX_PATH } from 'configs/AppConfig'

// Resource constants (must match backend)
export const RESOURCES = {
  DASHBOARD: 'dashboard',
  USERS: 'users',
  DOCUMENTS: 'documents',
  BACKUPS: 'backups',
  LEARNING: 'learning',
};

// Dashboard
const dashboardNavTree = [{
  key: 'dashboard',
  path: `${APP_PREFIX_PATH}/dashboard`,
  title: 'Dashboard',
  icon: DashboardOutlined,
  breadcrumb: false,
  isGroupTitle: true,
  submenu: [
    {
      key: 'app-dashboard',
      path: `${APP_PREFIX_PATH}/dashboard`,
      title: 'Dashboard',
      icon: DashboardOutlined,
      breadcrumb: false,
      submenu: [],
      permission: { resource: RESOURCES.DASHBOARD, action: 'read' }
    },
  ]
}];

// Administration group - User management, backups
const adminNavTree = [{
  key: 'administration',
  path: `${APP_PREFIX_PATH}/admin`,
  title: 'Administration',
  icon: SettingOutlined,
  breadcrumb: false,
  isGroupTitle: true,
  submenu: [
    {
      key: 'app-users',
      path: `${APP_PREFIX_PATH}/admin/users`,
      title: 'User Management',
      icon: UserOutlined,
      breadcrumb: false,
      submenu: [],
      permission: { resource: RESOURCES.USERS, action: 'read' }
    },
    {
      key: 'app-backups',
      path: `${APP_PREFIX_PATH}/admin/backups`,
      title: 'Backup & Restore',
      icon: CloudServerOutlined,
      breadcrumb: false,
      submenu: [],
      adminOnly: true, // Only visible to admins
    },
    {
      key: 'app-maintenance',
      path: `${APP_PREFIX_PATH}/admin/maintenance`,
      title: 'Maintenance Mode',
      icon: ToolOutlined,
      breadcrumb: false,
      submenu: [],
      adminOnly: true,
    }
  ]
}];

// Learning / French PR section
const learningNavTree = [{
  key: 'learning',
  path: `${APP_PREFIX_PATH}/learning`,
  title: 'Learning / French PR',
  icon: BookOutlined,
  breadcrumb: false,
  isGroupTitle: true,
  submenu: [
    {
      key: 'app-learning-courses',
      path: `${APP_PREFIX_PATH}/learning/courses`,
      title: 'Courses',
      icon: BookOutlined,
      breadcrumb: false,
      submenu: [],
      permission: { resource: RESOURCES.LEARNING, action: 'read' }
    },
    {
      key: 'app-learning-levels',
      path: `${APP_PREFIX_PATH}/learning/levels`,
      title: 'Levels (CEFR)',
      icon: TrophyOutlined,
      breadcrumb: false,
      submenu: [],
      permission: { resource: RESOURCES.LEARNING, action: 'read' }
    },
    {
      key: 'app-learning-modules',
      path: `${APP_PREFIX_PATH}/learning/modules`,
      title: 'Modules',
      icon: ReadOutlined,
      breadcrumb: false,
      submenu: [],
      permission: { resource: RESOURCES.LEARNING, action: 'read' }
    },
    {
      key: 'app-learning-lessons',
      path: `${APP_PREFIX_PATH}/learning/lessons`,
      title: 'Lessons',
      icon: FormOutlined,
      breadcrumb: false,
      submenu: [],
      permission: { resource: RESOURCES.LEARNING, action: 'read' }
    },
    {
      key: 'app-learning-students',
      path: `${APP_PREFIX_PATH}/learning/students`,
      title: 'Student Progress',
      icon: TeamOutlined,
      breadcrumb: false,
      submenu: [],
      permission: { resource: RESOURCES.LEARNING, action: 'read' }
    },
    {
      key: 'app-learning-entitlements',
      path: `${APP_PREFIX_PATH}/learning/entitlements`,
      title: 'Manage Entitlements',
      icon: CrownOutlined,
      breadcrumb: false,
      submenu: [],
      permission: { resource: RESOURCES.LEARNING, action: 'update' }
    },
    {
      key: 'app-learning-plans',
      path: `${APP_PREFIX_PATH}/learning/plans`,
      title: 'Pricing Plans',
      icon: DollarOutlined,
      breadcrumb: false,
      submenu: [],
      permission: { resource: RESOURCES.LEARNING, action: 'update' }
    },
    {
      key: 'app-learning-ordering',
      path: `${APP_PREFIX_PATH}/learning/ordering`,
      title: 'Ordering Tools',
      icon: OrderedListOutlined,
      breadcrumb: false,
      submenu: [],
      permission: { resource: RESOURCES.LEARNING, action: 'update' }
    },
    {
      key: 'app-learning-assessments',
      path: `${APP_PREFIX_PATH}/learning/assessments`,
      title: 'Level Final Quizzes',
      icon: FileProtectOutlined,
      breadcrumb: false,
      submenu: [],
      permission: { resource: RESOURCES.LEARNING, action: 'read' }
    },
    {
      key: 'app-learning-content-pages',
      path: `${APP_PREFIX_PATH}/learning/content-pages`,
      title: 'Content Pages',
      icon: FileTextOutlined,
      breadcrumb: false,
      submenu: [],
      permission: { resource: RESOURCES.LEARNING, action: 'update' }
    },
    {
      key: 'app-learning-payments',
      path: `${APP_PREFIX_PATH}/learning/payments`,
      title: 'Payments',
      icon: TransactionOutlined,
      breadcrumb: false,
      submenu: [],
      permission: { resource: RESOURCES.LEARNING, action: 'update' }
    },
    {
      key: 'app-learning-promoters',
      path: `${APP_PREFIX_PATH}/learning/promoters`,
      title: 'Promoters & Promos',
      icon: TeamOutlined,
      breadcrumb: false,
      submenu: [],
      permission: { resource: RESOURCES.LEARNING, action: 'update' }
    },
    {
      key: 'app-learning-test-practice',
      path: `${APP_PREFIX_PATH}/learning/test-practice`,
      title: 'Test Practice (TEF/TCF)',
      icon: FileProtectOutlined,
      breadcrumb: false,
      submenu: [],
      permission: { resource: RESOURCES.LEARNING, action: 'read' }
    },
    {
      key: 'app-learning-english-speaking',
      path: `${APP_PREFIX_PATH}/learning/english-speaking`,
      title: 'English Speaking Tests',
      icon: SoundOutlined,
      breadcrumb: false,
      submenu: [],
      permission: { resource: RESOURCES.LEARNING, action: 'read' }
    },
    {
      key: 'app-learning-ai-examiner',
      path: `${APP_PREFIX_PATH}/learning/ai-examiner`,
      title: 'AI Examiner (Live)',
      icon: CustomerServiceOutlined,
      breadcrumb: false,
      submenu: [],
      permission: { resource: RESOURCES.LEARNING, action: 'read' }
    },
    {
      key: 'app-learning-audit-logs',
      path: `${APP_PREFIX_PATH}/learning/audit-logs`,
      title: 'Audit Logs',
      icon: AuditOutlined,
      breadcrumb: false,
      submenu: [],
      adminOnly: true,
    },
    {
      key: 'app-learning-seed',
      path: `${APP_PREFIX_PATH}/learning/seed`,
      title: 'Seed & Migration (Dev)',
      icon: DatabaseOutlined,
      breadcrumb: false,
      submenu: [],
      adminOnly: true,
    },
  ]
}];

const navigationConfig = [
  ...dashboardNavTree,
  ...learningNavTree,
  ...adminNavTree,
]

export default navigationConfig;
